import { Component, OnInit } from '@angular/core';
import {FeatureFlagsService} from "../../services/feature-flag/feature-flags.service";

@Component({
  selector: 'sb-feature-flag-reset',
  templateUrl: './feature-flag-reset.component.html',
  styleUrls: ['./feature-flag-reset.component.scss']
})
export class FeatureFlagResetComponent implements OnInit {

  constructor(public featureFlagsService: FeatureFlagsService) { }

  ngOnInit(): void {
  }

  reset() {
    this.featureFlagsService.resetFlagsToDefault();
  }
}
